export class UpdateTitle  {
    public static readonly type = '[Crumb] UpdateTitle';
    constructor(public title: string) {}
}
export class ConfirmNavigation {
    static readonly type = '[Crumb] Confirm Navigation';
    constructor(public allowNavigation: boolean) {}
}
